/**
 * A project-scoped Amp workload identity subject (`amp orb id-token --subject-scope project`):
 * `workspace:<workspace-id>:project:<project-id>` or `user:<owner-user-id>:project:<project-id>`.
 * Thread-, user- and workspace-scoped subjects have a different number of segments and don't match.
 */
const AMP_PROJECT_SUBJECT = /^(workspace|user):([^:\s]+):project:([^:\s]+)$/

export function parseAmpProjectSubject(subject: string | null | undefined) {
	const match = subject && subject.length <= 200 ? AMP_PROJECT_SUBJECT.exec(subject) : null
	return match ? { ownerType: match[1] as 'workspace' | 'user', ownerId: match[2], projectId: match[3] } : null
}
